import { BasePage } from '@/components/ui/base-page'

export function SystematicEquityPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add SystematicEquityPage specific content here */}
    </BasePage>
  )
}